import { ClientUserState } from './ClientUserState.ts';
import { UIDeviceController } from './ui_html/UIDeviceController.ts';
import { UIUrlController } from './ui_html/UIUrlController.ts';
import { StorageWrapper } from './StorageWrapper.ts';
export class ClientPlatformRedirection {
    static handlePlatformRedirection() {
        if (!UIDeviceController.isUserOnMobileWebBrowser()) return;
        if (this.shouldSkipAnyRedirection()) return;
        this.handleRedirectToMobileWeb();
    }
    static isUserOnLandingPage() {
        var _ClientUserState_userState, _ClientUserState_userState1;
        // Should be similar logic in code/client/web/views/pages/ejs_shared/first-scene-detection.ejs
        if (!UIUrlController.isUrlPathRoot()) return false;
        if (this.isOnMobilePath()) return false;
        if ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn) return false;
        var _ClientUserState_userState_totalCompletedGameCount;
        const hasCompletedOneGame = ((_ClientUserState_userState_totalCompletedGameCount = (_ClientUserState_userState1 = ClientUserState.userState) === null || _ClientUserState_userState1 === void 0 ? void 0 : _ClientUserState_userState1.totalCompletedGameCount) !== null && _ClientUserState_userState_totalCompletedGameCount !== void 0 ? _ClientUserState_userState_totalCompletedGameCount : 0) > 0;
        if (hasCompletedOneGame) return false;
        return true;
    }
    static shouldSkipAnyRedirection() {
        if (!UIDeviceController.isUserOnMobileDevice()) return true;
        if (UIDeviceController.isUserOnTabletDevice()) return true;
        if (this.isUserOnLandingPage()) {
            const hasNoRoomId = UIUrlController.getRoomIdFromUrl() == undefined;
            return hasNoRoomId;
        }
        const isRulebookPage = window.location.pathname.includes('/catan-rules');
        if (isRulebookPage) return true;
        const isTimerPage = window.location.pathname.includes('/timer');
        if (isTimerPage) return true;
        return false;
    }
    static isOnMobilePath() {
        return window.location.pathname.includes('/mobile');
    }
    static handleRedirectToMobileWeb() {
        StorageWrapper.setPortraitGamePlayEnabled(true);
        if (this.isOnMobilePath()) return;
        const languagePrefix = UIUrlController.getLanguagePrefix();
        const newUrl = languagePrefix + '/mobile' + UIUrlController.getRelativeUrlWithoutLanguagePrefix();
        // eslint-disable-next-line no-restricted-syntax
        window.location.href = this.removeTrailingSlash(newUrl);
    }
    static removeTrailingSlash(url) {
        return url.replace(/\/([?#])/, '$1');
    }
}
